import React from 'react';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';

export const DesktopTableCell = ({
    value,
    span,
    extraClass,
}) => {
    const valueSanitized = StringUtilService.sanitizeHtml(value);

    return <div
        style={{ gridColumn: `span ${span}` }}
        className={extraClass}
    >
        <div
            className="loyalty-levels-table-desktop__content-wrap"
            dangerouslySetInnerHTML={{ __html: valueSanitized }}
        ></div>
    </div>;
};
